import React from "react";
import "../../../pages/Surveys/style.css"
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";

 
import { FaTimes, FaEdit, FaFileExport,FaArrowRight, FaExclamationCircle, FaTimesCircle, FaCheckCircle } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
import { Spinner } from "reactstrap";
const PendingAdvances = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);
  const toggle = () => setshowModal(!showModal);


  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [showModal, setshowModal] = useState(false);
  const [selected_advance, setSelectedAdvance] = useState([])
const [status, setstatus] = useState(10001)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const get_month_name=(month)=>{

    const date = new Date(2024, month-1, 1);   
    const month_name = date.toLocaleString('default', { month: 'long' });
    return month_name;
   }
  const onBtnExport = useCallback((params) => {
    var params = {
      columnKeys: [
        "staff_id",
        "staff_name",
        "email",
        "role_name",
        "office_name",
        "contract_start_date",
        "contract_end_date",
        "contract_expires_after",
      ],
      fileName: `EmployeeList-${window.h.get_half_formattedDate()}.csv`,
    };
    gridRef.current.api.exportDataAsCsv(params);
  }, []);
  useEffect(() => {
    fetch_data();
    return () => {};
  }, []);

  const fetch_data = () => {
    setIsLoading(true);
 
    genericGet(ENDPOINTS.LIST_PENDING_ADVANCES)
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setRowData(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
    });
   
  };

  const approveAdvance =  (status) => {
   if(!window.confirm("Are you sure to proceed ?")){
    
    return;
   }
    setIsLoading(true)
 
 
 

   let data= 
    {
      "advance_id":selected_advance?.id,
      "status":status
  }
     
  
  
   
  console.clear();
  console.log(data);
  
  
  genericPost(ENDPOINTS.SALARY_ADVANCE_ACTION, data)
  .then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
            console.log("Save Payroll Response",response.data);
              cogoToast.success(response.data.message, {
                  hideAfter: 5,
              });
               setshowModal(false);
              fetch_data();
          } else {
              cogoToast.error(response.data.message, {
                  hideAfter: 5,
              });
          }
      }
  })
  .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
      });
  });
   
   
  }
  return (
    <div>
          <h1> Pending Actions</h1>
      <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          //   overlayLoadingTemplate={
          //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          //   }

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => history.push({
            pathname: LOCAL_PATHS.LEAVE_PENDING_ACTIONS,
            state: { data: e.data },
          })}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

           
            {
              headerName: "Staff Name ",
              field: "staff_name",
              sortable: true,
              filter: true,
            
            },
            {
              headerName: "Date requested ",
              field: "date_requested",
              sortable: true,
              filter: true,
             
            },
            {
              headerName: "Amount requested ",
              field: "amount_requested",
              sortable: true,
              filter: true,
             
            },

            {
              headerName: "Actions",
              field: "",
              sortable: true,
              filter: true,
             
              cellRendererFramework: (e) => {
                return (
                 
    

                  <button
                  className="badge btn-primary"
                    onClick={() => {
               setshowModal(true);
               setSelectedAdvance(e.data);
                    }}
                  >
                    View Details  &nbsp;  <FaArrowRight style={{ color: "white", cursor: "pointer" }} />
                  </button>
                  
                  
                  
           

                );
              },
            },




          ]}
        ></AgGridReact>

<Modal
        isOpen={showModal}
        onHide={() => setshowModal(false)}
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
             SAVE PAYROLL 
               
               
          </div>
           
          
         </ModalHeader>
        <ModalBody>
      

        
          <h3> Advance Payment Plan   :
          <table className="info_table">
  <thead>
    <th>Year</th>
    <th>Month</th>
    <th>Amount</th>
 


  </thead>
  {selected_advance?.deduction_plan?.map((plan)=>{
    return <tr> <td>{plan.year}</td>    <td>{ get_month_name(plan.month)}</td>   <td>{plan.amount}</td> 
    
    </tr>
  })}
  
</table>
             </h3>


<div className="row">

  
 
  
 

    <div className="col-md-6">
    <br/>
    {!is_loading?
    <button   onClick={()=>approveAdvance(10001)}    className="btn btn-primary" value="" >Approve</button> : <button className="btn btn-primary"  ><Spinner /> &nbsp; Processing..</button>  }


 
</div>
 
<div className="col-md-6">  
 

<br/>
 
  {!is_loading?
    <button  onClick={()=>approveAdvance(10002)}     className="btn btn-danger" value="" >Reject</button> : <button className="btn btn-danger"  ><Spinner /> &nbsp; Processing..</button>  }

    </div>
    </div>
     
     
        </ModalBody>
      
      </Modal>

      </div>{" "}
    </div>
  );
};

export default PendingAdvances;
